export const DistrictType = {
    1: 'jerusalem',
    2: 'north',
    3: 'haifa',
    4: 'center',
    5: 'telAviv',
    6: 'south',
    12: 'stateReligious',
};

